import { FC } from 'react'
import { RemoveBrandingCard } from '../../../../../../components/RemoveBranding/RemoveBrandingCard'
import { Stack } from '@dtx-company/design-system/src'
import { stopPropagationEvents } from '../../LinkEditDrawer/LinkEditDrawer.utils'

/**
 * Wrapper for RemoveBrandingCard with styles for mobile
 */
export const RemoveBrandingMenu: FC = () => {
  return (
    <Stack sx={theme => ({ p: theme.spacing(4, 0.75) })} {...stopPropagationEvents}>
      <RemoveBrandingCard />
    </Stack>
  )
}
